// extracted by mini-css-extract-plugin
module.exports = {"partnerWithUs":"PartnerWithUs--partnerWithUs--IzdFJ","action":"PartnerWithUs--action--2lbEm"};